// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__8SesK","search":"Settings_search__U1e0z","filter":"Settings_filter__2ZjQ5"};